import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { CancelButton, FormButton } from "../../../../components/Botton";
import Loader from "../../../../components/Loader";
import useEditSubject from "./useEditSubject";
import { IAddSubject, ISubjectId } from "../../Subject.props";

const EditSubject: React.FC<ISubjectId> = ({ subjectId, setSelectedSubjectId }) => {
  const {
    formData,
    loading,
    languages,
    courses,
    standard,
    handleChange,
    handleSubmit,
    handleCancel,
  } = useEditSubject(subjectId, setSelectedSubjectId);

  const {
    register,
    handleSubmit: useFormSubmit,
    formState: { errors },
    reset
  } = useForm<IAddSubject>();

  // Reset form with new data when formData changes
    useEffect(() => {
      if (formData && Object.keys(formData).length > 0) {
        reset(formData);
      }
    }, [formData, reset]);

  const [filteredCourses, setFilteredCourses] = useState(courses);

  // Filter courses when standard is selected
  useEffect(() => {
    if (formData.standard) {
      setFilteredCourses(courses.filter(course => course.standard === formData.standard));
    } else {
      setFilteredCourses(courses); // Reset to all courses if no standard is selected
    }
  }, [formData.standard, courses]);

  const fields = [
    {
      label: "Language",
      name: "languageName",
      type: "select",
      options: languages,
    },
    {
      label: "Education",
      name: "standard",
      type: "select",
      options: standard,
    },
    {
      label: "Stream",
      name: "courseName",
      type: "select",
      options: filteredCourses,
    },
    {
      label: "Subject",
      name: "subject",
      type: "text",
    },
  ] as const;

  return (
    <div className="flex flex-col items-center w-full h-screen p-8">
      <div className="bg-white shadow-md rounded-lg pt-6 pb-6 w-full">
        <div className="border-b-2 w-full">
          <h1 className="text-3xl mb-2 text-gray-700 ml-5">Edit Subject</h1>
        </div>
        {loading && <Loader />}
        <form onSubmit={useFormSubmit(handleSubmit)} className="space-y-6">
          <fieldset className="m-2 rounded border-opacity-60 bg-white">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 m-4">
              {fields.map((field) => (
                <div key={field.name}>
                  <label
                    className="block text-gray-700 text-base font-semibold mb-2"
                    htmlFor={field.name}
                  >
                    {field.label}:
                  </label>
                  {field.type === "select" ? (
                    <select
                      id={field.name}
                      {...register(field.name, { required: true })}
                      onChange={handleChange}
                      value={formData[field.name]}
                      className="appearance-none border rounded w-full py-2 px-3 text-gray-600 leading-tight focus:outline-none focus:shadow-outline"
                    >
                      <option value="">Select {field.label}</option>
                      {field.options.map((option) => (
                        <option key={option._id} value={option[field.name]}>
                          {option[field.name]}
                        </option>
                      ))}
                    </select>
                  ) : (
                    <input
                      className="appearance-none border rounded w-full py-2 px-3 text-gray-600 leading-tight focus:outline-none focus:shadow-outline"
                      type={field.type}
                      id={field.name}
                      {...register(field.name, { required: true })}
                      value={formData[field.name]}
                      onChange={handleChange}
                    />
                  )}
                  {errors[field.name] && (
                    <p className="text-red-500 text-sm mt-1">
                      {field.label} is required.
                    </p>
                  )}
                </div>
              ))}
            </div>
          </fieldset>
          <div className="flex justify-start mt-6 ml-10">
            <FormButton
              className="py-2 px-4 rounded mr-4"
              type="submit"
              children="Update"
            />
            <CancelButton
              className="py-2 px-4 rounded"
              onClick={handleCancel}
              children="Cancel"
              type="button"
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditSubject;
